export default __webpack_public_path__ + "assets/audios/915c0e94093a7bf5243f8d8858f0f8b9.mp3";